export * from './message-info_detail.component';



// WEBPACK FOOTER //
// ./src/app/modules/shared/component/message-info_detail/index.ts